module.exports = __webpack_public_path__ + "media/bootstrap-icons/list-task-a475770e.svg";